import $ from "jquery";
import { stringIsEmptyOrWhitespace } from "../utils/string";

// Validates a combo of radio buttons and value input
$.validator.addMethod("required-combo-value", function (value, element, parameters) {
	let elements = $("[name='" + element.name + "']"),
		selectedValue = null;

	selectedValue = elements.filter(":checked").val();

	if (stringIsEmptyOrWhitespace(selectedValue)) {
		selectedValue = elements.filter(":not(:radio)").val();
	}

	return !stringIsEmptyOrWhitespace(selectedValue);
});

$.validator.unobtrusive.adapters.addBool("required-combo-value");